import { vars } from '@repo/config';
import { createPostFetchOptions } from './helper';

export async function revokeAppleToken(
  cookieHeader: string,
  userId: string,
): Promise<{ revoked: boolean }> {
  const url = new URL('/revoke-apple-token', vars.url.identityUrl);
  const response = await fetch(
    url.toString(),
    createPostFetchOptions({ cookieHeader, body: { userId } }),
  );

  if (!response.ok) {
    return { revoked: false };
  }

  return (await response.json()) as { revoked: boolean };
}
